import script from "./LoadingCountdown.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingCountdown.vue?vue&type=script&setup=true&lang=js"

import "./LoadingCountdown.vue?vue&type=style&index=0&id=60898673&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60898673"]])

export default __exports__